import { atom } from "jotai";

export const colaboradorAtom = atom([]);
export const listaOrganigramaAtom = atom([]);
export const dataAtom = atom([]);

export const visibleModalDomicilioAtom = atom(false);
export const visibleModalDatosNacimientoAtom = atom(false);
export const visibleModalContactoEmergenciaAtom = atom(false);
export const visibleModalRegimenPensionarioAtom = atom(false);
